/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../Stages/StagesCase";
import { getRequiredFields, validateFields } from "../statusChangeValidators";
import { TrafficAccident } from "../../../types/Products/TrafficLaw/TrafficAccident/TrafficAccident";
import _ from "lodash";
import { abstractLitigationCaseValidators } from "../AbstractLitigationCase/abstractLitigationCaseValidators";

export const trafficAccidentValidators = {
    ...abstractLitigationCaseValidators,
    [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: (trafficAccidentCase: TrafficAccident) => {
    let errorMessages = validateFields(getRequiredFields(trafficAccidentCase, stagesCase.STAGE_DATA_COMPLETED_LAWFIRM), trafficAccidentCase);
    errorMessages.push(...validateClaimsForDamages(trafficAccidentCase));
    return errorMessages;
  },
  [stagesCase.STAGE_CHECKED]: (trafficAccidentCase: TrafficAccident) => {
    let errorMessages = validateFields(getRequiredFields(trafficAccidentCase, stagesCase.STAGE_CHECKED), trafficAccidentCase);
    errorMessages.push(...validateClaimsForDamages(trafficAccidentCase));
    return errorMessages;
  },
};

const validateClaimsForDamages = (trafficAccidentCase: TrafficAccident) => {

  if (trafficAccidentCase.caseCategoryAssessment === "reject") {
    return [];
  }

  let errorMessages = [];

  if (_.isEmpty(trafficAccidentCase.claimsForDamages)) {
    errorMessages.push("Das Feld \"Schadensersatzansprüche\" muss ausgefüllt sein!");
  }

  if (_.some(trafficAccidentCase.claimsForDamages, (claimExtension) => !claimExtension.extensionValue)) {
    errorMessages.push("Mindestens ein \"Höhe Schadensersatz\" Wert fehlt");
  }

  return errorMessages;
};
